<div class="counts" *ngIf="utilityCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Utilities <span>{{ utilityCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'utilityCounts', 'utilitiesRequired']"
      >
        <p class="count">Utilities Required</p>
        <span>{{ utilityCounts.utilitiesRequired }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'utilityCounts', 'utilitiesRequested']"
      >
        <p class="count">Utilities Requested</p>
        <span>{{ utilityCounts.utilitiesRequested }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'utilityCounts', 'utilitiesCompleted']"
      >
        <p class="count">Utilities Completed</p>
        <span>{{ utilityCounts.utilitiesCompleted }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
